import script from "./Contact-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Contact-item.vue?vue&type=script&setup=true&lang=js"

import "./Contact-item.vue?vue&type=style&index=0&id=58a8a9f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a8a9f8"]])

export default __exports__